import React, { useEffect, useMemo } from 'react';
import { PageHeader } from '../../components/PageHeader';
import { Tabs } from '../../components/Tabs';
import type { TabDef } from '../../components/Tabs';
import { useProjects } from '../../hooks/useProjects';
import { clearCurrentProject } from '../../services/angular-bridge';
import { FavoritesTab } from './FavoritesTab';
import { AllProjectsTab } from './AllProjectsTab';
import { LoadingPlaceholder } from '../../components/LoadingPlaceholder';

export function ProjectListPage() {
  const { data: projects = [], isLoading, isError } = useProjects();

  // Leaving project scope for the list must drop the Angular ProjectService's
  // current project — otherwise the top search bar (which watches
  // ProjectService.CurrentProjectChanged) stays visible.
  useEffect(() => {
    clearCurrentProject();
  }, []);

  const favoriteProjects = useMemo(() => projects.filter(p => p.favorite), [projects]);

  const tabs: TabDef[] = [
    {
      id: 'favorites',
      heading: <><i className="fas fa-star" aria-hidden="true" style={{marginRight: "6px"}} />Favorites</>,
      content: <FavoritesTab projects={favoriteProjects} />,
    },
    {
      id: 'allProjects',
      heading: <><i className="fas fa-gavel" aria-hidden="true" style={{marginRight: "6px"}} />All Projects</>,
      content: <AllProjectsTab projects={projects} />,
    },
  ];

  if (isLoading) return <LoadingPlaceholder label="Loading projects…" />;
  if (isError) return <div className="alert alert-danger">Failed to load projects.</div>;

  return (
    <div>
      <PageHeader icon="fas fa-gavel" title="Projects" />
      <br />
      <Tabs tabs={tabs} defaultTab="favorites" testId="project-list-tabs" />
    </div>
  );
}
